import React, { useState, useEffect } from "react";
import { message, Row } from "antd";
import { metaDataGroupManage } from '../../services/metadataGroupService';
import MetadataFields from "./metaDataGroupField";
import Grid from "../../components/commonFields/Grid";
import { CheckOutlined } from "@ant-design/icons";

const GROUPTYPE_DEFAULT = 0;

const MetadataGroup = () => {
    const [metadataGroups, setMetadataGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [groupSearch] = useState('');
    const [isAddGroup, setIsAddGroup] = useState(false);

    useEffect(() => {
        fetchMetadataGroups();
    }, []);

    const fetchMetadataGroups = async () => {
        const payload = {
            groupId: 0,
            groupName: "",
            groupType: null,
            actionType: "get",
            fieldConfigData: '',
            groupDesc: "",
        };
        try {
            setLoading(true);
            const response = await metaDataGroupManage(payload);
            //console.log("Get response", response);
            if (response.success) {
                const processedGroups = response.data.group.map(group => ({
                    groupId: group.groupId,
                    groupType: group.groupType,
                    groupName: group.GroupName,
                    description: group.description,
                    configData: group.configData ? JSON.parse(group.configData) : {}
                }));
                setMetadataGroups(processedGroups);
            }
        } catch (error) {
            message.error("Failed to load client details.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (record) => {
        try {
            const payload = {
                groupId: record.groupId,
                groupName: "",
                groupType: "",
                actionType: "delete",
                fieldConfigData: null,
                groupDesc: ""
            };
            const response = await metaDataGroupManage(payload);
            //console.log("response delete", response);
            if (response?.success) {
                fetchMetadataGroups();
                message.success("Client Data Group deleted successfully!");
            } else {
                message.error(response?.businessRules);
                console.log("Workflow list are:", response?.data);
            }
        } catch (error) {
            message.error("Failed to delete Client Data Group.");
        }
    };
    const handleAddGroupClick = () => {
        const emptyGroup = {
            groupId: null,
            groupName: "",
            description: "",
            groupType: GROUPTYPE_DEFAULT,
            configData: {
                GroupName: "",
                Unique: [],
                Indexes: {},
                Fields: []
            }
        };

        setSelectedGroup(emptyGroup);
        setIsAddGroup(true);
    };

    const columns = [
        {
            title: "Group Name",
            dataIndex: "groupName",
            key: "groupName",
            ellipsis: true,
        },
        {
            title: "Global Group",
            dataIndex: "groupType",
            key: "groupType",
            width: 120,
            tag: true,
            tagColor: "#0e8617",
            boolean: true, //consider the 1 or 0 is true or false to set 'tag' if it is 'true'
        },
        {
            title: 'Actions',
            key: 'actions',
            dataIndex: 'actions',
            width: 100,
            fixed: 'right',
            render: ['edit', 'delete'],
            ellipsis: true,

        },
    ];

    const filteredGroups = groupSearch
        ? metadataGroups.filter(group =>
            group.groupName?.toLowerCase().includes(groupSearch.toLowerCase())
        )
        : metadataGroups;

    const goBackToGroups = () => {
        setSelectedGroup(null);
        setIsAddGroup(false);
        fetchMetadataGroups();
    };

    const handleEditClick = (group) => {
        setSelectedGroup(group);
        setIsAddGroup(false);
    };

    const handleGroupSave = (updatedGroup) => {
        setSelectedGroup(updatedGroup); // updates state with new groupId
    };

    return (
        <>
            {!selectedGroup && !isAddGroup ? (
                <div>
                    <h2>Client Data Groups</h2>
                    <Row gutter={7} style={{ marginBottom: 16 }}>
                        {/* <Col span={4}>
                            <Button type="primary" onClick={handleAddGroupClick}>Add Group</Button>
                        </Col> */}
                    </Row>
                    {/* <Drawer
                        title={editingGroup ? "Update Client Data Group" : "Add Client Data Group"}
                        placement="right"
                        className="custom-drawers cus-drawer-sm"
                        onClose={() => setIsDrawerVisible(false)}
                        open={isDrawerVisible}
                        footer={
                            <div style={{ textAlign: 'right' }}>
                                <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
                                    {editingGroup ? "Update" : "Add"}
                                </Button>
                                {editingGroup && <Button style={{ marginLeft: '15px' }} onClick={handleClear}> Clear</Button>}
                            </div>
                        }
                    >
                        <Form form={form} onFinish={handleSave} layout="vertical">
                            <Form.Item label="Group Name" name="groupName" rules={[{ required: true, message: "Enter Group Name" }]}>
                                <Input placeholder="Group Name" />
                            </Form.Item>
                            <Form.Item label="Group Type" name="groupType" valuePropName="checked">
                                <Checkbox />
                            </Form.Item>
                        </Form>
                    </Drawer> */}
                    <Grid
                        columnData={{ columns: columns }}
                        tableData={filteredGroups}
                        loading={loading}
                        rowKey="groupId"
                        createButton={true}
                        createButtonName={'Add Group'}
                        createButtonIcon={<CheckOutlined />}
                        handleCreate={handleAddGroupClick}
                        searchButton={true}
                        downloadCSV={true}
                        showEdit={true}
                        showDelete={true}
                        csvFileName="ClientDataGroup"
                        paginationConfig={{ pageSizeOptions: ['10', '20', '50', '100'] }}
                        className="custom-grid-class"
                        handleEdit={handleEditClick}
                        handleDelete={handleDelete}
                    />
                </div>
            ) : (
                <MetadataFields
                    group={selectedGroup}
                    isNewGroup={isAddGroup}
                    goBack={goBackToGroups}
                    allGroups={metadataGroups}
                    onSaveGroup={handleGroupSave}
                />
            )}
        </>
    );
};

export default MetadataGroup;